<template>
  <div>
    <b-card
      v-show="resettingpassword==false"
      class="mx-auto col-12 col-md-8 col-lg-6 px-0 mx-0 border-0"
    >
      <b-card-title>
        <div
          class="col-12 pt-4 pb-4 text-center"
          :class="gdqmodeclass"
          style="color: white;"
        >
          <img
            src="../assets/GDQ-Associates-White.svg"
            width="300"
            alt="GDQ Logo"
          >
        </div>
      </b-card-title>
      <b-alert
        :show="passwordhasbeenreset"
        variant="success"
      >
        {{ message }}
      </b-alert>
      <b-alert
        :show="gdq_recertification"
        variant="warning"
        v-html="gdq_recertification_text"
      />
      <b-form @submit.prevent="login">
        <b-form-group
          label="Enter your username"
          invalid-feedback="Incorrect or incomplete login information"
        >
          <b-form-input
            :class="`${anon ? 'g-anon' : '' }`"
            v-model="i_name"
            :state="i_name_valid"
          />
        </b-form-group>
        <b-form-group
          label="Enter your password"
          invalid-feedback="Incorrect or incomplete login information"
        >
          <b-form-input
            v-model="i_password"
            type="password"
            :state="i_password_valid"
          />
        </b-form-group>
        <b-card
          v-if="otp_setup"
          class="col-12 mx-auto"
          title="Two-factor authentication required"
        >
          <b-card-body>
            <p>
              You have not set up two-factor authentication yet. Please scan the QR code below in your authenticator app , then enter the code from your authenticator app in the field below and click "Set up".
            </p>
            <div class="text-center">
              <img
                :src="qrCodeUrl"
                alt=""
                class="my-4"
                title="Scan this QR code with your authenticator app"
              />
            </div>
            <b-form-group
              class="pt-4"
            >
              <b-form-label>
                Enter the code from your authenticator app:
              </b-form-label>
              <b-form-input
                v-model="otp_setup_code"
                type="text"
                placeholder="Code"
              />
            </b-form-group>
          </b-card-body>
        </b-card>
        <b-form-group v-if="otp" label="Two factor authentication">
          <b-form-input
            v-model="otp_code"
            type="text"
            placeholder="Enter the code from your authenticator app"
          />
        </b-form-group>
        <b-form-group v-if="otpemail" label="A one-time login code has been sent to your e-mail, please enter the code">
          <b-form-input
            v-model="otpemail_code"
            type="text"
            placeholder="Please enter e-mailed code"
          />
        </b-form-group>
        <b-form-group
          v-if="otp_setup || otp"
          class="col-12 mx-auto text-center"
        >
          <b-button
            class="col-12 col-sm-6"
            type="submit"
            variant="primary"
          >
            <b-spinner
              v-show="loading==true"
              small
              class="mr-2 py-0"
            />
            <span class="icon-key ml-2 mr-2" />{{ otp_setup ? 'Set up' : 'Login' }}
          </b-button>
        </b-form-group>
        <div
          v-if="!otp_setup && !otp"
          class="col-12 mx-auto text-center"
        >
          <b-button
            class="col-12 col-sm-6"
            type="submit"
            variant="primary"
          >
            <b-spinner
              v-show="loading==true"
              small
              class="mr-2 py-0"
            />
            <span class="icon-key ml-2 mr-2" />Login
          </b-button>
        </div>
        <div class="col-12 mx-auto mt-2 text-center">
          Do you want to change your password? Click <a
            href="javascript: return false"
            @click.prevent="resetpassword"
          >here</a> to reset it.
        </div>
      </b-form>
    </b-card>

    <b-card
      v-show="login_text.length > 10"
      class="mx-auto col-12 col-md-8 col-lg-6 px-0 mx-0 border-0"
    >
      <div
        class="col-12 pt-4 pb-4 text-left bg-default"
        v-html="login_text"
      />
    </b-card>
    <b-card
      v-show="resettingpassword==true"
      class="mx-auto col-12 col-md-8 col-lg-6 px-0 mx-0 border-0"
    >
      <b-card-title>
        <div
          class="col-12 pt-4 pb-4 bg-primary text-center"
          style="color: white;"
        >
          <img
            src="../assets/GDQ-Associates-White.svg"
            width="300"
            alt="GDQ Logo"
          >
        </div>
      </b-card-title>
      <h4>Reset password </h4>
      <b-form @submit.prevent="sendpasswordlink">
        <b-form-group
          label="Enter your e-mail address"
          invalid-feedback="Invalid e-mail address"
        >
          <b-form-input
            :class="`${anon ? 'g-anon' : '' }`"
            v-model="passwordemail"
            :state="passwordemail_valid"
          />
        </b-form-group>
        <b-row>
          <div class="col-12 col-lg-5 text-left pb-4">
            <b-button
              class="col-12"
              type="submit"
              variant="default"
              @click.prevent="resettingpassword=false"
            >
              <span class="mr-2" />Back to login
            </b-button>
          </div>
          <div class="col-12 col-lg-7 text-right">
            <b-button
              class="col-12"
              type="submit"
              variant="primary"
              @click.prevent="sendpasswordlink"
            >
              <span class="icon-key mr-2" />Send me the link!
            </b-button>
          </div>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>
<script>
import { config } from '../../config'
export default {
  name: 'Login',
  components: {
  },
  data () {
    return {
      gdqmodeclass: (config.mode == 'live') ? 'bg-primary' : config.mode == 'stage' ? 'bg-warning' : 'bg-danger',
      i_name: '',
      i_name_valid: true,
      i_password: '',
      i_password_valid: true,
      resettingpassword: false,
      passwordhasbeenreset: false,
      user: null,
      message: '',
      passwordemail: '',
      passwordemail_valid: null,
      loading: false,
      lastlogin_months: 0,
      gdq_recertification_months: 1000,
      gdq_recertification_text: '',
      gdq_recertification: false,
      login_text: '',
      otp_setup: false,
      otp_setup_code: '',
      qrCodeUrl: '',
      otp: false,
      otp_code: '',
      otp_secret: '',
      otpemail: false,
      otpemail_code: ''
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    }
  },
  created () {
    this.consultantstatuses_get()
    this.get_recertification_params()
    this.get_login_text()
  },
  methods: {
    consultantstatuses_get () {
      this.$store.dispatch('consultantstatuses_fetch')
    },
    get_login_text () {
      this.$store.dispatch('syspref_get', { name: 'login_text' })
        .then((resp) => {
          this.login_text = resp.data.value
        })
    },
    get_recertification_params () {
      this.$store.dispatch('syspref_get', { name: 'gdq_recertification_months' })
        .then((resp) => {
          this.gdq_recertification_months = resp.data.value
          this.$store.dispatch('syspref_get', { name: 'gdq_recertification_text' })
            .then((resp) => {
              this.gdq_recertification_text = resp.data.value
            })
        })
    },
    lastlogin (user, profile) {
      // This one works, but we need to reset i_user.last_login to i_user.prev_login,
      // otherwise the user can log in the second time
      const checkdate = profile.certification_date > user.last_login ? profile.certification_date : user.last_login
      this.lastlogin_months = 0
      if (checkdate !== null) {
        const d1 = new Date(checkdate.replace(' ', 'T'))
        const d2 = new Date()
        let months = 0
        months = (d2.getFullYear() - d1.getFullYear()) * 12
        months -= d1.getMonth() + 1
        months += d2.getMonth() + 1
        this.lastlogin_months = months
      }
    },
    parse_email (email) {
      // eslint-disable-next-line
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;   
      return pattern.test(email.toLowerCase())
    },
    sendpasswordlink () {
      var formok = true
      if (!this.parse_email(this.passwordemail)) {
      // if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.passwordemail) == false) {
        formok = false
      }
      if (!formok) {
        this.passwordemail_valid = false
      }
      // -----------------------------------------------
      // Look up whether we have a user for this e-mail
      // -----------------------------------------------
      var filter = {
        email: {
          operator: '=',
          value: this.passwordemail
        }
      }
      this.$store.dispatch('forgotpassword', { filter: filter })
        .then((resp) => {
          var status = resp.data.status
          this.passwordhasbeenreset = false
          this.message = ''
          if (status === 'OK') {
            this.passwordhasbeenreset = true
            this.message = 'An e-mail has been sent to ' + this.passwordemail + '. Please follow the instructions in the e-mail to reset your password.'
          }
          this.resettingpassword = false
        })
    },
    resetpassword () {
      this.resettingpassword = true
    },
    login () {
      this.loading = true
      this.i_name = this.i_name.trim()
      this.i_password = this.i_password.trim()
      const i_name = this.i_name
      const i_password = this.i_password
      const i_otp = this.otp ? this.otp_code : this.otp_setup_code
      const i_otpemail = this.otpemail ? this.otpemail_code : ''
      this.$store.dispatch('login', { i_name, i_password, i_otp, i_otpemail })
        .then(() => {
          this.$store.dispatch('user_fetch')
            .then(() => {
              this.$store.dispatch('profile_fetch', {})
                .then(() => {
                  this.loading = false
                  this.i_name_valid = true
                  this.i_password_valid = true
                  this.gdq_recertification = false
                  this.lastlogin(this.$store.state.user, this.$store.state.profile)
                  if (parseInt(this.lastlogin_months) > parseInt(this.gdq_recertification_months)) {
                    this.gdq_recertification = true
                    // Disabled
                    this.gdq_recertification = false
                  }
                  if (!this.gdq_recertification) {
                    // Set last login on successful login and no recertification
                    this.$store.dispatch('lastlogin_set', { id: this.$store.state.user.id })
                      .then(() => {
                        console.log(this.$store.state.profile.consultantstatus_id)
                        const consultantstatus = this.$store.state.consultantstatuses.find(s => s.id === this.$store.state.profile.consultantstatus_id)
                        // if (consultantstatus.can_do_survey == '0' && consultantstatus.can_do_elearning == '1') {
                        //   this.$router.push('learninghub');
                        // } else {
                        this.$router.push('/')
                        // }
                      })
                  }
                })
            })
        })
        .catch(err => {
          if (err.response) {
            this.loading = false
            // Check for the x-two-factor-required header
            const twoFactorRequired = err.response.headers['x-two-factor-required']
            if (twoFactorRequired === 'true') {
              console.log('Two-factor authentication required')
              // Handle two-factor authentication requirement
              if (err.response.data.status === '2fa_setup') {
                console.log('Setup')
                this.otp_setup = true
                this.qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURI(err.response.data.qr)}&amp;size=200x200`
              }
              if (err.response.data.status === '2fa') {
                this.otp_secret = err.response.data.secret
                this.otp_setup = false
                this.otp = true
              }
              return
            }
            const twoFactorEmailRequired = err.response.headers['x-two-factor-email-required']
            if (twoFactorEmailRequired === 'true') {
              this.otpemail = true
              return
            }
          }
          this.i_name_valid = false
          this.i_password_valid = false
          this.loading = false
        })
    }
  }
}
</script>
<style scoped>
</style>
